import { all, fork } from 'redux-saga/effects'

import authSagas from '@/containers/Login/AuthSagas'
import pageConfigurationSagas from '@/store/PageConfiguration/PageConfigurationSagas'
import usersManagementSagas from '@/containers/UsersManagement/UsersManagementSagas'
import servicesStatusSagas from '../containers/ServicesStatus/ServicesStatusSagas'
import carbonOffsetsSagas from '../containers/CarbonOffsetManagement/CarbonOffsetsSagas'
import officesManagementSagas from '../containers/OfficesManagement/OfficesManagementSagas'
import teamsManagementSagas from '../containers/TeamsManagement/TeamsManagementSagas'
import assistanceSagas from '../containers/AssistanceProductsManagement/AssistanceSagas'
import dashboardSagas from '../containers/DashboardPage/DashboardSagas'
import monConseillerPersoSagas from '../containers/MonConseillerPersoProductsManagement/MonConseillerPersoSagas'
import subscriptionFormV2Sagas from '../containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormV2Sagas'
import clientCallbacksSagas from '@/containers/ClientCallbacksPage/ClientCallbacksSagas'
import additionalProductsToolsSagas from '../containers/AdditionalSalesManagement/additionalProductsToolsSagas'
import searchContactsSagas from '../containers/ContactSearchPage/searchContactsSagas'
import contactsToolsSagas from '@/containers/DevToolsNew/Contacts/contactsSagas'
import podUpdaterSagas from '@/containers/DevToolsNew/PodUpdater/podUpdaterSagas'
import commandsSagas from '@/containers/DevToolsNew/Commands/commandsSagas'
import communicationBoardSagas from '@/containers/DevToolsNew/CommunicationBoard/communicationBoardSagas'
import nettingUpdaterSagas from '@/containers/OrganizationsManagement/NettingUpdater/nettingUpdaterSagas'
import organizationsManagementSagas from '@/containers/OrganizationsManagement/organizationsManagementSagas'
import offerCutPeriodsSagas from '@/containers/OrganizationsManagement/OfferForm/AvailabilityTab/offerCutPeriodsSagas'
import dashboardV2Sagas from '@/containers/DashboardPageV2/DashboardV2Sagas'
import homeSagas from '@/containers/HomePage/HomeSagas'

export default function* rootSaga() {
  yield all([
    fork(authSagas),
    fork(pageConfigurationSagas),
    fork(usersManagementSagas),
    fork(servicesStatusSagas),
    fork(carbonOffsetsSagas),
    fork(officesManagementSagas),
    fork(teamsManagementSagas),
    fork(assistanceSagas),
    fork(monConseillerPersoSagas),
    fork(dashboardSagas),
    fork(subscriptionFormV2Sagas),
    fork(searchContactsSagas),
    fork(clientCallbacksSagas),
    fork(additionalProductsToolsSagas),
    fork(contactsToolsSagas),
    fork(podUpdaterSagas),
    fork(commandsSagas),
    fork(communicationBoardSagas),
    fork(nettingUpdaterSagas),
    fork(organizationsManagementSagas),
    fork(offerCutPeriodsSagas),
    fork(dashboardV2Sagas),
    fork(homeSagas),
  ])
}
